module.exports = __webpack_public_path__ + "img/disc-02.212c851e.svg";